<template>
  <Modal
    :title="$t('appointment.label.updateFci')"
    name="UPDATE_FCI"
    width="325"
    actions
  >
    <template v-slot:body>
      <v-form @submit.prevent="update" lazy-validation>
        <v-text-field
          v-model="amount"
          v-money="catalogCurrency()"
          :label="$t('appointment.label.fci')"
          class="amount inputAmount mx-auto"
          hide-details="auto"
          outlined
        />
      </v-form>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeModal('UPDATE_FCI')"
        :disabled="isFciUpdating"
        elevation="0"
        class="mr-5"
        color="grey"
        large
        text
      >
        {{ $t('forms.cancel') }}
      </v-btn>
      <v-btn
        @click="update"
        :loading="isFciUpdating"
        color="primary"
        elevation="0"
        large
        dark
      >
        {{ $t('appointment.buttons.confirm') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/app/Modal'

import { clearCurrency } from '@/util/helpers'
import { catalogCurrency } from '@/util/catalog'
import { mapGetters, mapActions } from 'vuex'
import { VMoney } from 'v-money'

export default {
  name: 'ModalUpdateFCI',

  components: {
    Modal,
  },

  directives: {
    money: VMoney
  },

  computed: {
    ...mapGetters(['appointment', 'isFciUpdating']),

    isAdmin() {
      return this.$route.path.includes('admin')
    },
  },

  methods: {
    ...mapActions(['closeModal', 'updateFci']),

    update() {
      const body = {
        id: this.appointment.id,
        fci: clearCurrency(this.amount),
        isAdmin: this.isAdmin,
      }

      this.updateFci(body)
    },

    resetField() {
      this.amount = 0
    }
  },

  data() {
    return {
      amount: 0,
      catalogCurrency,
    }
  }
}
</script>
